import { AiFeedContent } from "./AiFeedContent";

/**
 * Option A: AI Feed rendered as a page inside the Medical Records left column.
 * Accessed via the Sparkles icon in the sidebar navigation.
 */
export function AiFeedSidebarPage() {
  return (
    <div className="h-full pb-3">
      <AiFeedContent />
    </div>
  );
}
